import "./IconTile.scss";

import clsx from "clsx";
import type { JSX } from "react";
import { FCC } from "types";

interface Props {
  icon?: JSX.Element;
  label?: string;
  selected?: boolean;
  dataTestId?: string;
  isMobile?: boolean;
  variant?: "default" | "sim-selection-variant";
}

export const IconTile: FCC<Props> = ({
  icon,
  label,
  selected,
  dataTestId = "icon-tile",
  isMobile,
  variant = "default",
}) => {
  const isSimSelectionVariant = variant === "sim-selection-variant";

  return (
    // A static indicator, not a control: inside the SIM form a <button>
    // would submit it.
    <div
      data-testid={dataTestId}
      className={clsx(
        "icon-tile",
        isSimSelectionVariant && "icon-tile--sim-selection-variant",
        selected && "selected",
        isMobile && [
          "h-auto w-full flex-row px-8 py-6",
          isSimSelectionVariant && "items-center justify-start gap-4",
        ],
      )}
    >
      {icon && (
        <div
          className={clsx(
            "icon-container",
            isMobile &&
              (isSimSelectionVariant ? "shrink-0 items-center" : "mr-2"),
          )}
        >
          {icon}
        </div>
      )}
      <p
        className={clsx(
          "label-container",
          isMobile && [
            "!w-full !justify-start !whitespace-normal !text-start",
            isSimSelectionVariant && "flex-1",
          ],
        )}
      >
        {label}
      </p>
    </div>
  );
};
